<template>
  <div class="container-item container-side-image image-card pt-3 pb-3">  
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-8 col-xl-7 col-12">
        <div>
          <ImageElement :imageData="imageData" />
        </div>
        <div v-if="cardText.text" class="text-left creditos-picture">
          <span v-html="cardText.text" v-if="cardText.text"></span>
          <span class="author">{{ cardText.imageCredits }}</span>
        </div>
      </div>
    </div>    
  </div>
</template>

<style lang="scss">

.creditos-picture {
  font-family: "Noto Sans";
  padding: 5px 15px;
  margin: 0 15px;
  color: #333;
  font-size: 14px;
  
  .author {
    font-size: 14px;
    color: #747474;
  }
}
</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'SingleImage',
    mixins: [images],
    props: {
      cardText: Object 
    }
  }
</script>